import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/VisibilityHidden.svg'

export const IconVisibilityHidden = IconSVG as IconComponent
